import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ComponentProps } from 'react';
type ThemeProviderProps = ComponentProps<typeof NextThemesProvider>;
const DEFAULT_THEME: ThemeProviderProps['defaultTheme'] = 'light';
const STORAGE_KEY = 'peoply-theme';
export const ThemeProvider = ({ children, storageKey, defaultTheme, ...props }: ThemeProviderProps) => (
  <NextThemesProvider
    attribute='class'
    defaultTheme={defaultTheme ?? DEFAULT_THEME}
    disableTransitionOnChange
    enableSystem
    storageKey={storageKey ?? STORAGE_KEY}
    {...props}
  >
    {children}
  </NextThemesProvider>
);
